import { useCallback } from "react";
import { useMatch, useNavigate } from "react-router";
import { createSearchParams, useSearchParams } from "react-router-dom";

import { RENEWALS_PATH } from "@routing/paths";

export function useOpenRenewalDetails() {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const match = useMatch(`/${RENEWALS_PATH}/*`);

  return useCallback(
    (renewalLocator: string) => {
      navigate({
        pathname: `/${RENEWALS_PATH}/${renewalLocator}`,
        search: !!match
          ? createSearchParams(searchParams).toString()
          : undefined,
      });
    },
    [navigate, searchParams]
  );
}
